import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import { getAppFeatures } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";
import _ from "lodash";
import { IAcademyCourse, IAcademyLesson } from "./academy.t";
import { ACADEMY_LESSONS_KEYS } from "./academyConstants";

const moduleSelector = (state: IRootState) => state.academy;

export const getIsAcademyInitedSelector = createSelector(
    moduleSelector, academy => academy.isInited,
);

export const getIsAcademyEnabledSelector = createSelector(
    getAppFeatures, features => !!features[FEATURES.ACADEMY],
);

export const getAcademyCoursesSelector = createSelector(
    moduleSelector, academy => _.sortBy(academy.courses, 'position'),
);

export const getAcademyCoursesByKeySelector = createSelector(
    moduleSelector, academy => _.keyBy(academy.courses, 'academy_course_key'),
);

export const getAcademyLessonsSelector = createSelector(
    moduleSelector, academy => _.sortBy(academy.lessons, 'position'),
);

export const getAcademyBeginnersGuideOnboardingLessonSelector = createSelector(
    getAcademyLessonsSelector, lessons => _.find(lessons, lesson =>
        lesson.academy_lesson_key === ACADEMY_LESSONS_KEYS.ONBOARDING),
);

export const getAcademyLessonsByKeySelector = createSelector(
    getAcademyLessonsSelector, lessons => _.keyBy(lessons, 'academy_lesson_key'),
);

export const makeSelectAcademyLessonsByCourseKey = (courseKey: IAcademyCourse['academy_course_key']) => createSelector(
    getAcademyLessonsSelector, lessons =>
        _.filter(lessons, lesson => lesson.academy_course_key === courseKey),
);

export const makeSelectAcademyLessonStepsByLessonKey = (lessonKey: IAcademyLesson['academy_lesson_key']) => createSelector(
    moduleSelector, academy => academy.steps[lessonKey] || [],
);

export const getAcademyCurrentlyCompletedLessonKeySelector = createSelector(
    moduleSelector, academy => academy.currentlyCompletedLessonKey,
);

export const getAcademyCurrentStepInfoStringSelector = createSelector(
    moduleSelector, academy => academy.currentStepInfoString,
);

export const getIsShowAcademyBeginnersGuideInviteSelector = createSelector(
    moduleSelector, academy => academy.isShowBeginnersGuideInvite,
);
